import { UserInfo } from '@microsoft/teamsfx';

import { AppError, ApiError } from 'src/errors';
import { ErrorCodes } from 'src/utils/enums';
import { ERROR_MESSAGES } from 'src/utils/constants';

type StateErrorConstructorParams = {
  message: string
  storeName: string
  user?: UserInfo | null
  originalError?: unknown
  context?: Record<string, unknown>
};

export class StateError extends AppError {
  public storeName: string;

  constructor({ message, storeName, user, originalError, context }: StateErrorConstructorParams) {
    super({ name: 'StateError', message, errorCode: ErrorCodes.STATE, user, originalError, context: { ...context, storeName } });
    this.storeName = storeName;
  }
}

export function handleStateError(error: unknown, storeName: string): void {
  // Skip logging if the error is already logged or if it is an API error
  if (error instanceof ApiError || (error instanceof AppError && error.isLogged)) {
    throw error;
  }

  const message = ERROR_MESSAGES.unexpectedStateError(
    storeName,
    error instanceof Error ? error.message : ERROR_MESSAGES.unknownError,
  );

  const stateError = new StateError({ message, storeName, originalError: error });

  stateError.logError();

  // Throw the error so that it can be caught by ErrorBoundaryProvider
  throw stateError;
}
